export const Archetype = ({ role, description, img }) => {
  return (
    <div className="archetype-box">
      <div className="archetype-image-container">
        <img src={img} alt={role} />
        <p className="role-text">{role}</p>
      </div>
      <span className="role-description-text">{description}</span>
    </div>
  );
};
